export function copyToClipboard(text: string) {
  return navigator.clipboard !== void 0
    ? navigator.clipboard.writeText(text)
    : new Promise((resolve, reject) => {
        const res = fallback(text);
        if (res) {
          resolve(true);
        } else {
          reject(res);
        }
      });
}

const handlers: any[] = [];

function trigger(e: Event) {
  handlers[handlers.length - 1](e);
}

function addFocusout(fn: Function) {
  handlers.push(fn);

  if (handlers.length === 1) {
    document.body.addEventListener('focusin', trigger);
  }
}

function removeFocusout(fn: Function) {
  const index = handlers.indexOf(fn);
  if (index > -1) {
    handlers.splice(index, 1);

    if (handlers.length === 0) {
      document.body.removeEventListener('focusin', trigger);
    }
  }
}

function fallback(text: string) {
  const area = document.createElement('textarea');
  area.value = text;
  area.contentEditable = 'true';
  area.style.position = 'fixed'; // avoid scrolling to bottom

  const fn = () => {};
  addFocusout(fn);

  document.body.appendChild(area);
  area.focus();
  area.select();

  const res = document.execCommand('copy');

  area.remove();
  removeFocusout(fn);

  return res;
}
